<template>
  <div class="bg-gerund-color pt-227 pb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="blog-details-content">
            <div class="blog-img mb-4">
              <img src="../../assets/images/blog-1.jpg" alt="blog" />
            </div>
            <span class="date">January 21, 2024</span>
            <h2>Demystifying Paid Search Ads: A Beginner's Guide</h2>
            <p class="mb-4">
              Welcome to the world of Paid Search Ads! If you're new to digital
              advertising and wondering how to effectively harness the power of
              search engines to drive targeted traffic and reach potential
              customers, you're in the right place. In this beginner's guide,
              we'll take you on a journey through the ins and outs of paid
              search ads, unraveling the complexities and providing you with
              essential tips to kickstart your successful advertising campaigns.
            </p>
            <p class="mb-4">
              In this chapter, we'll the groundwork by explaining paid search
              ads are and how they function. You'll gain insights into popular
              advertising platforms like Google Ads and Bing Ads, and we'll
              explore the numerous benefits these ads offer
            </p>

            <div class="row">
              <div class="col-lg-4 mb-4">
                <div class="blog-img h-100">
                  <img
                    src="../../assets/images/blog-5.jpg"
                    class="object-fit-cover h-100"
                    alt="blog"
                  />
                </div>
              </div>
              <div class="col-lg-8 mb-4">
                <div class="blog-img mb-4">
                  <img src="../../assets/images/blog-6.jpg" alt="blog" />
                </div>
                <div class="blog-img">
                  <img src="../../assets/images/blog-7.jpg" alt="blog" />
                </div>
              </div>
            </div>

            <p class="mb-4">
              Unravel the components that make up a successful search ad in this
              chapter. From captivating headlines to compelling descriptions and
              strategically placed URLs, we'll delve into the art of crafting ad
              copy that engages and resonates with your target audience. With a
              focus on relevant keywords and match types, you'll learn how to
              optimize your ads for maximum impact and relevancy.
            </p>

            <p class="mb-4">
              Ready to create your first paid search ad campaign? This chapter
              will guide you through the process step-by-step. You'll learn how
              to define your advertising goals, structure campaigns and ad
              groups effectively, and set appropriate budgets and bidding
              strategies. Armed with this knowledge, you'll be ready to launch
              your campaign with confidence.
            </p>

            <div class="d-sm-flex justify-content-between tag-social">
              <ul
                class="ps-0 mb-0 list-unstyled tags d-flex align-items-center"
              >
                <li>
                  <img src="../../assets/images/tag.png" alt="tag" />
                </li>
                <li>
                  <router-link to="/services">Paid Advert</router-link>
                </li>
              </ul>
              <ul
                class="ps-0 mb-0 list-unstyled social-link d-flex align-items-center mt-3 mt-sm-0"
              >
                <li>
                  <span>Share</span>
                </li>
                <li>
                  <a href="https://www.facebook.com/" target="_blank">
                    <img
                      src="../../assets/images/icon-facebook.png"
                      alt="icon-facebook"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/" target="_blank">
                    <img
                      src="../../assets/images/icon-linkedin.png"
                      alt="icon-linkedin"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/" target="_blank">
                    <img
                      src="../../assets/images/icon-twitter.png"
                      alt="icon-twitter"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/" target="_blank">
                    <img
                      src="../../assets/images/icon-instagram.png"
                      alt="icon-instagram"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/" target="_blank">
                    <img
                      src="../../assets/images/icon-youtube.png"
                      alt="icon-youtube"
                    />
                  </a>
                </li>
              </ul>
            </div>

            <div class="d-flex justify-content-between post-nect-prev pb-75">
              <router-link to="/our-blog" class="text-decoration-none">
                <img src="../../assets/images/post-left.png" alt="post-left" />
                <span class="ms-3">Previous Post</span>
              </router-link>
              <router-link to="/our-blog" class="text-decoration-none">
                <span class="me-3">Next Post</span>
                <img
                  src="../../assets/images/post-right.png"
                  alt="post-right"
                />
              </router-link>
            </div>

            <div class="post-comment">
              <h4>Post A Comment</h4>

              <form>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group mb-4">
                      <textarea
                        class="form-control"
                        placeholder="Your comment"
                        cols="30"
                        rows="6"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group mb-4">
                      <input
                        type="text"
                        class="form-control rounded-pill"
                        placeholder="Your Name"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group mb-4">
                      <input
                        type="email"
                        class="form-control rounded-pill"
                        placeholder="Your Email"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group mb-4">
                      <input
                        type="text"
                        class="form-control rounded-pill"
                        placeholder="Website"
                      />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="form-group mb-4">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Save my name, email, and website in this browser for
                          the next time I comment.
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="form-group">
                      <button type="submit" class="default-btn border-0">
                        SUBMIT NOW
                        <img
                          src="../../assets/images/icon-right-white.png"
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <SideBar />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SideBar from "./SideBar.vue";

export default defineComponent({
  name: "BlogDetails",
  components: {
    SideBar,
  },
});
</script>

<style lang="scss" scoped>
.blog-details-content {
  img {
    border-radius: 20px;
  }
  .date {
    display: block;
    font-size: 14px;
    margin-bottom: 10px;
  }
  h2 {
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 25px;
  }
  .tag-social {
    margin-top: 65px;
    border-bottom: 1px solid #e1e1e1;
    padding-bottom: 38px;
    margin-bottom: 38px;
    .tags {
      li {
        position: relative;
        padding-left: 10px;

        a {
          font-weight: 700;
          font-size: 15px;
          font-family: var(--headingFontFamily);
          color: var(--headingColor);
          text-decoration: none;
          &:hover {
            color: var(--mainColor);
          }
        }
        &::before {
          content: ",";
          position: absolute;
          left: 0;
          top: 0;
          font-weight: 700;
          font-size: 15px;
          font-family: var(--headingFontFamily);
        }
        &:first-child {
          padding-left: 0;
          &::before {
            display: none;
          }
        }
        &:nth-child(2) {
          &::before {
            display: none;
          }
        }
      }
    }
    .social-link {
      li {
        margin-right: 15px;
        transition: var(--transition);

        &:last-child {
          margin-right: 0;
        }
        &:hover {
          transform: translateY(-2px);
        }
      }
    }
  }
  .post-nect-prev {
    a {
      span {
        font-size: 18px;
        font-weight: 700;
        font-family: var(--headingFontFamily);
        color: #4c4c4c;
      }
    }
  }
  .post-comment {
    border-radius: 10px;
    border: 1px solid var(--headingColor);
    background-color: var(--whiteColor);
    padding: 50px 80px;
    h4 {
      font-size: 28px;
      margin-bottom: 18px;
    }
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .blog-details-content {
    h2 {
      font-size: 22px;
      margin-bottom: 15px;
    }
    .tag-social {
      margin-top: 30px;
    }
    .post-nect-prev {
      a {
        span {
          font-size: 15px;
        }
      }
    }
    .post-comment {
      padding: 25px;
      h4 {
        font-size: 22px;
      }
    }
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .blog-details-content {
    h2 {
      font-size: 30px;
      margin-bottom: 15px;
    }
    .tag-social {
      margin-top: 30px;
    }
    .post-nect-prev {
      a {
        span {
          font-size: 15px;
        }
      }
    }
    .post-comment {
      padding: 25px;
      h4 {
        font-size: 22px;
      }
    }
  }
}
/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .blog-details-content {
    .post-comment {
      padding: 50px;
    }
  }
}
</style>